import { createSelector } from 'reselect';

import { AuthState } from './reducers';

const authState = (state: { auth: AuthState }): AuthState => state.auth;

export const AuthSelectors = {
  getIsLoggedIn: createSelector(authState, state => state.loggedIn)
};
